import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Se encarga de las dos formas de volver arriba:
 *
 * 1. Al cambiar de ruta devuelve la vista al inicio. En una SPA el navegador
 *    conserva el scroll, así que al entrar a otra página desde el pie se
 *    aterrizaba a media pantalla.
 * 2. Muestra un botón flotante después de 300 px de scroll.
 *
 * Debe renderizarse dentro de <BrowserRouter> porque usa useLocation.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(document.documentElement.scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    // Sin este removeEventListener cada montaje dejaba un listener vivo.
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <button
      type="button"
      className="btnScrollUp"
      aria-label="Volver al inicio de la página"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    />
  );
};

export default ScrollToTop;
